import React from "react";

function Experience() {
  return (
    <section className="tc-experience-style1 section-padding-x">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-2">
            <div className="exp-num mb-100 wow zoomIn" data-wow-delay="0.3s">
              <h5 className="fsz-18 text-uppercase">
                years of <br /> experience
              </h5>
              <h2 className="num"> 7+  </h2>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="img wow">
              <img
                src="/home1/assets/img/exp.png"
                alt=""
                className="img-cover"
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="info wow fadeInUp" data-wow-delay="0.3s">
              <h3 className="fsz-45 fw-600 mb-30"> Building Dreams Since 7+ Years </h3>
              <div className="text fsz-15 color-666">
                {/* Beri Studio is an archiectural practice based in Boston. We cut
                ourteeth on designing and creating buildings that are both
                beautiful and sustainable. */}
                {/* With years of experience and a passion for design, we are your trusted partner in creating exceptional outdoor spaces. */}
                Founded by Mudit Beri in 2017, BDA is dedicated to crafting innovative spaces that reflect our clients' visions and lifestyles. With a presence in Madhya Pradesh, Delhi, and Pune, we specialize in residential, commercial, and institutional designs, focusing on both aesthetics and functionality. Committed to sustainability, we integrate eco-friendly practices into our projects. Collaboration is key, ensuring every detail aligns with our clients’ aspirations. Together, we create enduring environments that inspire and elevate everyday living.
              </div>
              <a
                href="/innerpages/about"
                className="butn rounded-pill mt-50 hover-bg-black bg-white"
              >
                <span>
                  About Founder <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>
          <div className="col-lg-2 d-none d-lg-block">
  <div className="rotate-txt justify-content-lg-end">
    <ul>
      <li>
        <a href="#">@beris.design.atelier</a>
      </li>
      <li>
        <a href="#">+91-9527638317</a>
      </li>
    </ul>
  </div>
</div>

        </div>
      </div>
      <img src="/home1/assets/img/c_line.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Experience;
